<template>
    <div class="listingCard">
        <div class="cardWrapper">
            <div class="card">
                <div class="special" v-if="listing.specialOffer" >{{ listing.specialOffer.content | removeHTML }}</div>
                <ImageCarousel additionalClasses="card-img" :images="computeSmallImages" @clickedImage="clickedCarousel(listing)" style="height: 200px"></ImageCarousel>
                <div class="card-body" @click="goToListing(listing)">
                    <h6 class="card-sub-title">{{ $t('common.keywords.listing') }} {{ listing.objectId }}</h6>
                    <v-clamp class="card-title" :max-lines="2" tag="h5">{{ listing.localizedName | localized }}</v-clamp>
                    <p class="locationParagraph"><i class="fas fa-map-marker-alt location"></i>{{ computeLocation }}</p>
                    <v-clamp class="card-text" :max-lines="5" tag="p">{{ listing.localizedDescription | localized }}</v-clamp>
                </div>
            </div>
            <div class="card-footer text-muted">
                <table width="100%" class="splitter">
                    <tr>
                        <td class="iconContainer" v-for="entry in iconProperties" :key="entry.text">
                            <i :class="computeClass(entry)" data-toggle="tooltip" data-placement="top" :title="entryTooltip(entry)"></i> 
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ImageCarousel from "@/components/common/ImageCarousel";
import VClamp from 'vue-clamp'
export default {
    name: "ListingCard",
    components: {
        ImageCarousel,
        VClamp
    },
    mounted() {
        $('[data-toggle="tooltip"]').tooltip();
    },
    computed: {
        computeLocation: function() {
            if (this.isUndefined(this.listing) || this.isUndefined(this.listing.address)) {
                return "UNKNOWN";
            }

            return `${this.listing.address.city}`;
            // return this.listing.address.street + ", " + this.listing.address.number + " - " + this.listing.address.cap + " " + this.listing.address.city
        },
        computeSmallImages() {
            if (this.isUndefined(this.listing) || this.isUndefined(this.listing.images)) {
                return [this.API_URL + "" + this.resolvePosterImage(undefined)]; 
            }

            // A small tick to trigger the default image
            if (this.listing.images.length === 0) {
                return [{
                    id: 1,
                    url: `${this.API_URL}${this.resolvePosterImage(undefined)}`
                }]
            }

            const that = this;
            
            let images =  this.listing.images.map(el => {
                return {
                    id: el.id,
                    url: `${this.STATIC_ASSETS_URL}/${el.small.filename}`
                }
            });



            return images;
        },
        iconProperties: function() {
            return [
                {
                    "data": this.listing.properties.childrenAllowed,
                    "icon": "fas fa-child",
                    "tooltip": this.$i18n.t('properties.childrenAllowed')
                },
                {
                    "data": this.listing.properties.internet.value,
                    "icon": "fas fa-wifi",
                    "tooltip": this.$i18n.t('properties.internet')
                },
                {
                    "data": this.listing.properties.dogsAllowed,
                    "icon": "fas fa-paw",
                    "tooltip": this.$i18n.t('properties.dogsAllowed')
                },
                {
                    "data": this.listing.properties.swimmingPool.value,
                    "icon": "fas fa-swimmer",
                    "tooltip": this.$i18n.t('properties.swimmingPool')
                },
                {
                    "data": this.listing.properties.grill.value,
                    "icon": "fas fa-fire-alt",
                    "tooltip": this.$i18n.t('properties.grill')
                },
                {
                    "data": this.listing.properties.wheelchairAccessible,
                    "icon": "fas fa-wheelchair",
                    "tooltip": this.$i18n.t('properties.wheelchairAccessible')
                },
                {
                    "data": this.listing.properties.winterAccessible,
                    "icon": "fas fa-snowflake",
                    "tooltip": this.$i18n.t('properties.winterAccessible')
                }
            ];
        },
    },
    methods: {
        computeClass: function(icon) {
            return icon.icon + " icon " + (icon.data === true ? "present" : "");
        },
        goToListing: function(entry) {
            window.open(`/${entry.objectId}`, '_blank');
        },
        clickedCarousel: function(arg) {
            return this.goToListing(arg);
        },
        entryTooltip: function(entry) {
            return `${entry.tooltip}: ${entry.data ? this.$i18n.t("common.generic.yes") : this.$i18n.t('common.generic.no')}`;
        }
    },
    props: {
        listing: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
    
    .listingCard {
        cursor: pointer;
        margin-top: 15px;
        margin-bottom: 15px;
    }


    table td + td { border-left: 1px solid rgb(165, 165, 165); }

    .icon {
        color: rgb(204, 204, 204);
        margin: 1px;
    }

    .icon.present {
        color: $primary-color !important;
    }

    .iconContainer {
        text-align: center;
    }

    

    .location {
        margin-right: 4px;
    }

    .locationParagraph {
        margin: 0;
    }

    // Customize the look of the card
    .cardWrapper {
        border-radius: 5px;
        -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
        -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
        // border: 1px solid rgb(165, 165, 165);
    }


    .card-title {
        margin-bottom: 0;
        min-height: 36px;
    }
    .card-sub-title {
        margin-bottom: 0;
        padding-bottom: 4px;
        color: #777;
    }


    .card {
        border: none;
        border-radius: $border-radius;
    }

    .card-body {
        padding: 10px;
    }

    .card-text {
        line-height: 20px;
        min-height: 100px;
        font-size: 13px;
    }

    .card-footer {
        border: none;
        border-radius: $border-radius;
        background-color: white;

        padding: 0;
        padding-left: 2px;
        padding-right: 2px;
        padding-top: 12px;
        padding-bottom: 12px;
        margin-left: 0;
        margin-right: auto;
    }


    table {
        width: 100%;
    }

    .special {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10000;
        width: 100%;
        background-color: #eab134;
        color: white;
        margin-bottom: 5px;
        padding: 5px;
        border-radius: 5px;
    }
</style>
